import clsx from "clsx";
import * as React from "react";
import { SocialListProps } from ".";

function SocialList({ children, className, ...props }: SocialListProps) {
    return (
        <div className={clsx("tmp-social__list", className)} {...props}>
            {children}
        </div>
    );
}

export default SocialList;
